<template>
  <div class="big active-doctor">
    <div class="container" style="padding: 10px 20px 20px 20px">
      <div class="search-box">
        <!-- 结算账期 -->
        <div class="item">
          <span style="margin-left: 10px">结算账期</span>

          <el-date-picker
            v-model="activeDoctorForm.month"
            type="month"
            format="yyyy-MM"
            value-format="yyyy-MM"
            placeholder="请选择"
            size="small"
            :picker-options="pickerOptions"
            clearable
          >
          </el-date-picker>
        </div>

        <!-- 账号 -->
        <div class="item">
          <span style="margin-left: 10px">账号</span>
          <el-input
            v-model="activeDoctorForm.phone"
            clearable
            size="small"
            style="width: 180px"
            placeholder="请输入"
          ></el-input>
        </div>

        <!-- 姓名 -->
        <div class="item">
          <span style="margin-left: 10px">姓名</span>
          <el-input
            v-model="activeDoctorForm.recommender_name"
            clearable
            size="small"
            style="width: 180px"
            placeholder="请输入"
          ></el-input>
        </div>

        <!-- 工号 -->
        <div class="item">
          <span style="margin-left: 10px">工号</span>
          <el-input
            v-model="activeDoctorForm.recommender_code"
            clearable
            size="small"
            style="width: 180px"
            placeholder="请输入"
          ></el-input>

          <el-button
            type="primary"
            size="small"
            style="margin-left: 20px"
            @click="seachEnterFun"
            >查询</el-button
          >

          <el-button type="primary" size="small" @click="resetBtn"
            >重置</el-button
          >

          <el-button
            type="primary"
            size="small"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('1934') : false
            "
            @click="exportBtn"
            >导出</el-button
          >
        </div>
      </div>

      <div style="color: #f56c6c; text-align: left; margin-bottom: 10px">
        注：由于订单数据按支付时间计算，建议每月7号之后导出结算数据
      </div>

      <div class="statistics-card">
        <!-- 2-3人 -->
        <el-card class="box-card">
          <div class="desc">
            <div class="value">{{ activeDoctorInfo.two_three }}</div>
            <div class="title">2-3人</div>
          </div>
        </el-card>
        <!-- 4-5人 -->
        <el-card class="box-card">
          <div class="desc">
            <div class="value">{{ activeDoctorInfo.four_five }}</div>
            <div class="title">4-5人</div>
          </div>
        </el-card>
        <!-- 6-7人 -->
        <el-card class="box-card">
          <div class="desc">
            <div class="value">{{ activeDoctorInfo.six_seven }}</div>
            <div class="title">6-7人</div>
          </div>
        </el-card>
        <!-- 8人以上 -->
        <el-card class="box-card">
          <div class="desc">
            <div class="value">{{ activeDoctorInfo.up_eight }}</div>
            <div class="title">8人以上</div>
          </div>
        </el-card>
        <!-- 奖励总计 -->
        <el-card class="box-card">
          <div class="desc">
            <div class="value">{{ activeDoctorInfo.total_reward }}元</div>
            <div class="title">奖励总计</div>
          </div>
        </el-card>
      </div>

      <div style="border: solid 1px #c9cbd6">
        <el-table
          v-loading="tableLoading"
          :data="activeDoctorData"
          tooltip-effect="dark"
          ref="multipleTable"
          style="width: 100%; min-width: 1000px"
          :header-cell-style="{ background: '#F5F5F5' }"
        >
          <el-table-column
            prop="recommender_info"
            label="员工信息"
            width="120"
            fixed="left"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.recommender_name }}</div>
              <div>{{ scope.row.recommender_code }}</div>
              <div>{{ scope.row.phone }}</div>
            </template>
          </el-table-column>

          <el-table-column
            prop="area_name"
            label="大区"
            width="auto"
            fixed="left"
          >
          </el-table-column>

          <el-table-column align="center">
            <template slot="header">
              <span style="color: #000">医生活跃情况（单位：天）</span>
            </template>
            <el-table-column
              v-for="item in tableHeader"
              :key="item.prop"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              :fixed="item.fixed"
            >
              <template slot-scope="scope">
                <div>
                  {{
                    JSON.stringify(scope.row[item.prop]) === "null"
                      ? ""
                      : scope.row[item.prop]
                  }}
                </div>
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column
            prop="total_price"
            label="奖励金额"
            width="auto"
            :fixed="false"
          >
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <pagination
        v-show="totalNum > 0"
        :total="totalNum"
        :page.sync="pagination.page"
        :limit.sync="pagination.pageNumber"
        @pagination="getList"
      />
    </div>
  </div>
</template>
  
  <script>
import _ from "lodash";
import dayjs from "dayjs";
import staff from "@/api/staff.js";
import Pagination from "@/components/Pagination/index";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      pickerOptions: {
        disabledDate: this.disabledDate,
      },
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      activeDoctorInfo: {},
      activeDoctorForm: {
        month: "",
        phone: "",
        recommender_name: "",
        recommender_code: "",
      },
      tableHeader: [
        {
          label: "2-3人",
          prop: "two_three",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "4-5人",
          prop: "four_five",
          width: "260",
          align: "center",
          fixed: false,
        },
        {
          label: "6-7人",
          prop: "six_seven",
          width: "260",
          align: "center",
          fixed: false,
        },
        {
          label: "8人以上",
          prop: "up_eight",
          width: "260",
          align: "center",
          fixed: false,
        },
      ],
      activeDoctorData: [],
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm");
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.initDate();
    this.getList();
  },
  methods: {
    initDate() {
      const date = new Date();
      date.setMonth(date.getMonth() - 1); // 将当前日期减去一个月
      // 设置日期为当月的第一天
      date.setDate(1);
      this.activeDoctorForm.month = dayjs(date).format("YYYY-MM");
    },
    disabledDate(date) {
      const today = new Date();
      const currentYear = today.getFullYear();
      const currentMonth = today.getMonth(); // 获取当前月份，0表示1月，11表示12月

      // 禁用当前月份之后的日期（不禁用当前月份）
      return (
        date.getFullYear() > currentYear ||
        (date.getFullYear() === currentYear && date.getMonth() > currentMonth)
      );
    },
    getList() {
      let params = Object.assign({}, this.pagination, this.activeDoctorForm);
      this.tableLoading = true;
      staff.recommenderActiveDoctorReward(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.activeDoctorData = data.list;
          this.activeDoctorInfo = data.count_data;
          this.totalNum = data.total;
          this.tableLoading = false;
        }
      });
    },
    seachEnterFun() {
      this.pagination.page = 1;
      this.getList();
    },
    resetBtn() {
      this.activeDoctorForm = {
        month: "",
        phone: "",
        recommender_name: "",
        recommender_code: "",
      };
      this.getList();
    },
    // 导出
    exportBtn() {
      let params = Object.assign({}, this.pagination, this.activeDoctorForm);
      const loading = this.$loading();
      staff
        .recommenderActiveDoctorRewardExport(params)
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            let host = `${document.location.protocol}//${window.location.host}${data.url}`;
            window.open(host);
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    // 查看详情
    // toDetails(row) {
    //   let { recommender_name, recommender_code } = row;
    //   this.$router.push({
    //     path: "/home/staff/staffAwardDetails",
    //     query: {
    //       recommender_code,
    //       recommender_name,
    //       month: this.activeDoctorForm.month,
    //     },
    //   });
    // },
  },
};
</script>
  
  <style lang="scss">
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.active-doctor {
  .search-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      span {
        display: inline-block;
        margin-right: 4px;
        text-align: right;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
    .item-content {
      // width: 100%;
      .el-date-editor {
        width: 100%;
      }
    }
  }
  .prompt {
    font-size: 12px;
    text-align: left;
    color: red;
    padding-left: 10px;
    margin-bottom: 10px;
  }
  .statistics-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    .box-card {
      width: 19%;
      height: 120px;
      .el-card__body {
        .desc {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .value {
            font-size: 20px;
            font-weight: bold;
            height: 50%;
          }
          .title {
            padding: 10px 0;
            height: 50%;
          }
        }
      }
    }
  }
}
.active-doctor-mess {
  width: 400px !important;
  .el-message-box__message {
    p {
      word-wrap: break-word;
    }
  }
}
.cus-passwordDia {
  .passwordDia-box {
    display: flex;
    align-items: center;
    .label {
      width: 100px;
    }
    .btn {
      margin-left: 10px;
    }
  }
}
</style>
  
  <style lang="scss">
.activeDoctorData-sendCardVisible {
  .content-box {
    padding: 20px 10px 0;
    .el-form-item__content {
      display: flex;
      align-items: center;
      .el-input-number {
        width: 100%;
      }
    }
  }
}
</style>
  